import React from 'react'
import data from '../data/projects.json'

import projectStyles from './projectStyles.scss'

const WorkProjects = () => (
  <div>
    <div class="flex flex-wrap">
      {data.Projects.map((project, i) => {
        return (
          <div
            key={i}
            class="w-full p-2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/3 mb-4"
          >
            <div className="p-3 border-2 border-solid border-blue rounded project">
              <div>
                <h1 className="mt-2">{project.title}</h1>
                <p className="mt-2">{project.para1}</p>
                <p
                  className="mt-2"
                  dangerouslySetInnerHTML={{
                    __html: `${'Company & Role: ' + project.companyAndRole}`,
                  }}
                />
                <p
                  className="mt-2 text-blue"
                  dangerouslySetInnerHTML={{
                    __html: `${'Tech Used: ' + project.tech}`,
                  }}
                />
              </div>
              {project.url && (
                <div className="buttonContainer">
                  {project.url && (
                    <button
                      className="mt-6 mb-2"
                      onClick={() => {
                        let url = project.url
                        window.location.replace(url)
                      }}
                    >
                      Visit Site
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        )
      })}
    </div>
  </div>
)
export default WorkProjects
